<template>
  <v-dialog
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
    @input="val = $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout align-center>
          <div class="headline">
            {{ $t('userManagementEditUserNames') }}
          </div>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :disabled="busy"
            :title="$t('cancel')"
            @click="abort()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-text-field
          ref="firstname"
          v-model="newFirstName"
          :counter="maxLengthFirstName"
          :rules="[rules.min, rules.firstname]"
          :label="$t('firstName')"
          @keydown.enter="confirm()"
        />
        <v-text-field
          v-model="newLastName"
          :counter="maxLengthLastName"
          :rules="[rules.min, rules.lastname]"
          :label="$t('lastName')"
          @keyup.enter="confirm()"
        />
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <btn-ok
            :loading="busy"
            :disabled="!formIsValid"
            round
            @click="confirm()"
          />
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnOk,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minLength: 1,
      maxLengthFirstName: 30,
      maxLengthLastName: 150,
      rules: {
        min: (value) => {
          return value.trim().length >= this.minLength || this.$t('tooShort');
        },
        firstname: (value) => {
          return (
            value.trim().length <= this.maxLengthFirstName || this.$t('tooLong')
          );
        },
        lastname: (value) => {
          return (
            value.trim().length <= this.maxLengthLastName || this.$t('tooLong')
          );
        },
      },

      newFirstName: '',
      newLastName: '',
    };
  },
  computed: {
    formIsValid() {
      const newFirstName = this.newFirstName.trim();
      const newLastName = this.newLastName.trim();
      return (
        newFirstName.length > 0 &&
        newFirstName.length <= this.maxLengthFirstName &&
        newLastName.length > 0 &&
        newLastName.length <= this.maxLengthLastName
      );
    },
  },
  watch: {
    show: function (show) {
      if (show) {
        this.setInitialValuesFromUser();
        this.$nextTick(() => {
          this.$refs.firstname.focus();
        });
      }
    },
  },
  methods: {
    resetFirstName() {
      this.newFirstName = this.user.first_name;
    },
    resetLastName() {
      this.newLastName = this.user.last_name;
    },
    setInitialValuesFromUser() {
      this.resetFirstName();
      this.resetLastName();
    },
    closeDialog() {
      this.$emit('update:show', false);
    },
    abort() {
      this.setInitialValuesFromUser();
      this.closeDialog();
      this.$emit('abort');
    },
    confirm() {
      this.$emit('confirm', this.newFirstName, this.newLastName);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EditUserNamesDialog.vue